import { jsx as _jsx } from "react/jsx-runtime";
/** Themed button. Colours come from `--cx-*`; never pass a literal colour here. */
export function Button({ variant = "primary", block = false, className, ...rest }) {
    const classes = ["cx-btn", `cx-btn--${variant}`, block ? "cx-btn--block" : "", className ?? ""]
        .filter(Boolean)
        .join(" ");
    return _jsx("button", { type: "button", className: classes, ...rest });
}
//# sourceMappingURL=Button.js.map